import { ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonFunctionsCrumbs } from '../constants';
import FormFunction, { FunctionForm } from 'system/components/functions/form';
import { useParams, useNavigate } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpFetch as useOldHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { Functionality } from 'shell/models/functionality';
import { HttpResponse } from 'shell/models/http-response';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
// import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';

const FunctionsEdit = (): ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const { put: editFunction } = useOldHttpFetch(`${__MANAGEMENT_API_URL__}/funzioni/${params.id}`);

  const [functions] = useHttpFetch<HttpResponse<Functionality>, FunctionForm>(
    `${__MANAGEMENT_API_URL__}/funzioni/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response) => {
        const dataFunction = response.data?.payload;
        return {
          id: dataFunction?.key?.codice.toString() || '',
          name: dataFunction?.nome || '',
          entity: dataFunction?.entita || '',
          event: dataFunction?.evento || '',
          contextLastUpdate: dataFunction?.note || '',
        };
      },
    }
  );

  const onOk = useCallback(
    (form: FunctionForm | undefined) => {
      editFunction({
        key: { codice: form?.id },
        nome: form?.name,
        entita: form?.entity,
        evento: form?.event,
        note: form?.contextLastUpdate,
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/funzioni');
      });
    },
    [editFunction]
  );

  if (functions.pristine || functions.isLoading) {
    return <></>;
  }

  const content =
    functions.pristine || functions.isLoading ? null : (
      <FormFunction
        title="Modifica Funzione"
        onOk={onOk}
        onCancel={() => {
          navigate('/sistema/funzioni');
        }}
        initialValues={functions.data as unknown as FunctionForm}
      />
    );

  return (
    <>
      <Breadcrumbs items={[...CommonFunctionsCrumbs, { name: 'Modifica Funzione' }]} />
      {content}
    </>
  );
};

FunctionsEdit.displayName = 'Function Edit';

export default FunctionsEdit;
